import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import './index.styles.css'

interface Props {
  title: string | React.ReactNode
  tooltipContent?: React.ReactNode
  compact?: boolean
}

const Title = ({ title, compact, tooltipContent }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Box
      className={`Title_title_${compact ? 'compact' : 'default'}`}
      flexDirection="row"
      alignItems="center"
    >
      <Text.Normal size="200" weight="semibold">
        {title}
      </Text.Normal>
      {!!tooltipContent && (
        <Tooltip
          attachment="bottom center"
          targetAttachment="top center"
          size="big"
          open={open}
          toggle={toggle}
          type="brand"
        >
          <div>
            <Icon.Small icon="question" encircled="grey800" />
          </div>
          {tooltipContent}
        </Tooltip>
      )}
    </Box>
  )
}

export default Title
